import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-16 border-t-4 border-gold" data-id="element-135">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-136">
        <div className="mb-8" data-id="element-137">
          <h2 className="font-serif font-bold text-2xl tracking-wide mb-2" data-id="element-138">
            ZENTRAL PRO™
          </h2>
          <p className="text-gold font-medium" data-id="element-139">
            El sistema N°1 para propietarios que construyen en Argentina.
          </p>
        </div>

        <p className="text-gray-400 max-w-xl mx-auto mb-10" data-id="element-140">
          Porque construir tu casa no debería costarte todos los fines de semana
          del año — ni más plata de la necesaria.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-300 mb-12" data-id="element-141">
          <a href="mailto:soporte.zentralpro@gmail.com" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-142">
            📧 soporte.zentralpro@gmail.com
          </a>
          <a href="https://instagram.com/_zentralpro" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-143">
            📲 @_zentralpro
          </a>
          <a href="https://www.zentralpro.com" className="hover:text-gold transition-colors flex items-center gap-2" data-id="element-144">
            🌐 www.zentralpro.com
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-xs text-gray-500 space-y-4" data-id="element-145">
          <p data-id="element-146">
            © Zentral Pro™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="italic text-gray-400" data-id="element-147">
            "El próximo fin de semana puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}